import { Alert } from "antd";
import type { ReactNode } from "react";

interface ErrorAlertProps {
  error: string | null | undefined;
  description?: ReactNode;
  style?: React.CSSProperties;
  closable?: boolean;
  onClose?: () => void;
}

export function ErrorAlert({ error, description, style, closable, onClose }: ErrorAlertProps) {
  if (!error) return null;
  return (
    <Alert
      type="error"
      message={error}
      description={description}
      showIcon
      style={style}
      closable={closable}
      onClose={onClose}
    />
  );
}
